import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { SubscriptionAccountAlertComponent } from './subscription-account-alert.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        MaterialModule
    ],
    declarations: [SubscriptionAccountAlertComponent],
    exports: [SubscriptionAccountAlertComponent]
})
export class SubscriptionAccountAlertModule {
}
